// extracted by mini-css-extract-plugin
export default {"layout":"ClientListPage_layout__CkqTL","content":"ClientListPage_content__W-C0Y"};